import { PLAYBACK_SPEEDS, playbackSpeedPreset, setPlaybackSpeed } from '../state/avalanche.ts';

/** Playback speed preset buttons (0.5×…10×), shared by the playback bar and the avalanche
 * panels: picking one sets the preset every new run plays at, and updates any run playing now. */
export function SpeedPresetButtons() {
  const speed = playbackSpeedPreset.value;
  return (
    <div class="segmented speed-presets">
      {PLAYBACK_SPEEDS.map((s) => (
        <button
          key={s}
          type="button"
          class={speed === s ? 'active' : ''}
          onClick={() => setPlaybackSpeed(s)}
        >
          {s}×
        </button>
      ))}
    </div>
  );
}
